export default {
  root: {
    flexShrink: 0,
    position: 'relative'
  },
  paperSticky: {
    top: 0
  }
};